import { useEffect, type JSX } from "react";

type SetWindowLocationProps = {
  location: string;
};

const SetWindowLocation = ({ location }: SetWindowLocationProps): JSX.Element => {
  useEffect(() => {
    window.location.assign(location);
  }, [location]);

  return <h5>Redirecting...</h5>;
};

export default SetWindowLocation;
